// extracted by mini-css-extract-plugin
export var button = "CookieBanner-module--button--7eeac";
export var buttonAccept = "CookieBanner-module--button-accept--1fa9a";
export var buttonConfigure = "CookieBanner-module--button-configure--77b74";
export var buttonRefuse = "CookieBanner-module--button-refuse--b9e04";
export var buttonsContainer = "CookieBanner-module--buttons-container--879b0";
export var container = "CookieBanner-module--container--9ab20";
export var header = "CookieBanner-module--header--92060";
export var icon = "CookieBanner-module--icon--d8283";
export var link = "CookieBanner-module--link--3dc64";
export var sentence = "CookieBanner-module--sentence--3bae8";